<template>
  <div class="main">
    <div class="title">
      <div class="left">
        <img src="../../static/mobile/ic_120.png" alt="" class="icon" />
        <div class="info">
          <div class="payraja">PayRaja</div>
          <div>{{ $t("Earn Money as a UPI Agent") }}</div>
        </div>
      </div>
      <div class="download" @click="download_apk">{{ $t("Download APK") }}</div>
    </div>
    <div
      class="banner"
      @click="download_apk"
      :class="locale == 'hi' ? 'hi-bg' : 'en-bg'"
    ></div>
    <div class="content">
      <div class="content-title">
        {{ $t("Become a UPI Payment Agent & Start Earning!") }}
      </div>
      <div class="data-box">
        <div class="data-title data-box-item">
          <div class="amount">{{ $t("Order Amount") }}</div>
          <div class="bonus-earn">
            <div class="bonus">
              <img
                src="../../static/mobile/ic_arow.png"
                alt=""
                class="ic_arow"
              />
              {{ $t("Bonus") }}
            </div>
            {{ $t("You Can Earn") }}
          </div>
        </div>
        <div
          v-for="(item, i) in datas"
          :key="i"
          class="data-item data-box-item"
        >
          <div class="amount">{{ item.amount }}</div>
          <div class="bonus-earn">
            <img src="../../static/mobile/ic_coin.png" alt="" class="ic_coin" />
            {{ item.bonus }}
          </div>
        </div>
      </div>
    </div>
    <div class="fixed-bottom">
      <div class="btn" @click="download_apk">
        <img
          src="../../static/mobile/ic_download.png"
          alt=""
          class="ic_download"
        />
        {{ $t("Download to Earn Money Now") }}
      </div>
      <img src="../../static/mobile/five_icon.png" alt="" class="five-icon" />
    </div>
    <!-- <div class="help" @click.stop="open_tg">
      <img src="../../static/mobile/ic_tg.png" alt="" class="ic_tg" />
      {{ $t("HELP") }}
    </div> -->
  </div>
</template>

<script>
import { download, chnup, loadPage } from "../utils/tools";
export default {
  data() {
    return {
      locale: "",
      tgUrl: "",
      datas: [
        {
          amount: "₹19999.95",
          bonus: "+₹400",
        },
        {
          amount: "₹34420.03",
          bonus: "+₹688.4",
        },
        {
          amount: "₹2999.95",
          bonus: "+₹60",
        },
        {
          amount: "₹9999.99",
          bonus: "+₹200",
        },
        {
          amount: "₹249.91",
          bonus: "+₹5",
        },
        {
          amount: "₹4999.98",
          bonus: "+₹100",
        },
        {
          amount: "₹300.02",
          bonus: "+₹6",
        },
        {
          amount: "₹499.93",
          bonus: "+₹10",
        },
      ],
    };
  },
  methods: {
    download_apk(event) {
      chnup("17");
      window.location.href =
        "https://d1fb2aqk1yyubf.cloudfront.net/apk365/com.payraja.app/PayRaja.apk";
    },
    open_tg() {
      const mpts = Date.now();
      let uuid = localStorage.getItem("uuid");
      if (!uuid) {
        uuid = this.create_uuid();
      }
      console.log(mpts, uuid);
      window.location.href = `https://d2k4z7x2ql166o.cloudfront.net/mp/h5/chatwoot/index.html?identifier=web_${uuid}&mpts=${mpts}`;
    },
    create_uuid() {
      let uuid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
      localStorage.setItem("uuid", uuid);
      return uuid;
    },
    getTgUrl() {
      var xhr = new XMLHttpRequest();
      var url = "https://api.happymoneyplant.com/api/kf/get_url";
      var _this = this;
      xhr.open("GET", url, true);
      xhr.setRequestHeader(
        "X-Auth-Track",
        "aid=1&code=1&lan=&cvc=1&cvn=1&chn=web&pkg=web&plt=web&fcm="
      );
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          var data = JSON.parse(xhr.responseText);
          _this.tgUrl = data.data.url;
        }
      };
      xhr.send();
    },
  },
  created() {
    chnup("16");
  },
  mounted() {
    chnup("18");
    this.locale = this.$i18n.locale;
    // await this.getTgUrl();
    console.log(this.$i18n.locale);
  },
};
</script>

<style scoped>
.main {
  background: #f2f2f3;
  position: relative;
  /* 
  padding: 0 3.33vw; */
  padding-bottom: 38.19vw;
}
.title {
  position: fixed;
  top: 0;
  width: calc(100% - 6.66vw);
  padding: 0 3.33vw;
  height: 19.44vw;
  background-color: #ffffff;
  box-shadow: 0vw 0.46vw 0.93vw 0vw rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #141c2f;
}
.title .left {
  display: flex;
  align-items: center;
  gap: 2.69vw;
  font-family: Helvetica;
  font-size: 2.78vw;
}
.payraja {
  font-family: Helvetica-Bold;
  font-weight: bold;
  font-size: 4.44vw;
}
.title .download {
  width: 36.11vw;
  height: 10.37vw;
  text-align: center;
  line-height: 10.37vw;
  background-color: #000000;
  border-radius: 5.19vw;
  color: #ffffff;
  font-family: Helvetica-Bold;
  font-weight: bold;
  font-size: 3.89vw;
  animation-name: scaleDraw;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 1s;
}
.icon {
  width: 11.11vw;
  height: 11.11vw;
}
.banner {
  margin-top: 19.44vw;
  width: 100%;
  height: 36.67vw;
}
.en-bg {
  background: url("../../static/mobile/banner_en.png");
  background-size: cover;
}
.hi-bg {
  background: url("../../static/mobile/banner_indi.png");
  background-size: cover;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content-title {
  font-family: Helvetica-Bold;
  font-weight: bold;
  font-size: 3.33vw;
  color: #000;
  padding: 1.53vw 0;
}
.data-box {
  width: 92.78vw;
  background-color: #ffffff;
  border-radius: 3.33vw;
}
.data-box-item {
  padding: 0 2.69vw;
  height: 10.74vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bonus-earn,
.bonus {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: normal;
}
.bonus-earn {
  min-width: 42%;
}
.bonus {
  color: #ff7a08;
  margin-right: 1.23vw;
  font-weight: bold;
}
.data-title {
  font-weight: bold;
  font-size: 3.33vw;
}
.ic_arow {
  width: 1.85vw;
  height: 2.5vw;
}
.data-item {
  height: 13.24vw;
  font-family: ArialMT;
  font-size: 4.44vw;
  color: #212121;
}
.data-item {
  border-top: 1px solid #f7f7fb;
}
.data-item .bonus-earn {
  color: #ff7a08;
}
.ic_coin {
  width: 4.44vw;
  height: 4.44vw;
  margin-right: 1.34vw;
}

.fixed-bottom {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  height: 33.33vw;
  background-color: #ffffff;
  border: solid 0.09vw #f0f0f1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.btn {
  line-height: 15vw;
  text-align: center;
  border: solid 0.28vw #fb6a00;
  width: 90.74vw;
  height: 15vw;
  background-color: #fb6a00;
  border-radius: 7.5vw;
  font-family: Helvetica-Bold;
  font-weight: bold;
  font-size: 5vw;
  color: #ffffff;
  animation-name: scaleDraw2;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 1s;
}
.ic_download {
  width: 4.44vw;
  height: 4.44vw;
}
.five-icon {
  width: 47.88vw;
  margin-top: 5.83vw;
}
.help {
  width: 27.41vw;
  height: 12.22vw;
  background-color: #2193cb;
  border-radius: 6.11vw 0vw 0vw 6.11vw;
  position: fixed;
  right: 0;
  top: 131.57vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Helvetica-Bold;
  font-weight: bold;
  font-size: 5.56vw;
  color: #ffffff;
}
.ic_tg {
  width: 5.56vw;
  height: 5.56vw;
  margin-right: 1.11vw;
}
@keyframes scaleDraw {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.1);
  }
  75% {
    transform: scale(1);
  }
}
@keyframes scaleDraw2 {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.03);
  }
  50% {
    transform: scale(1.03);
  }
  75% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Google.vue